var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import { createBottomTabNavigator } from '@react-navigation/bottom-tabs';
import { getActionFromState, getStateFromPath } from '@react-navigation/native';
import { useAtomValue } from 'jotai';
import React, { useEffect } from 'react';
import { accessTokenAtom } from '@/atoms/Auth';
import { color } from '@/constant/color';
import { getDeferredDeepLinkUrl, setDeferredDeepLinkUrl, } from '@/deeplink/DeferredDeepLink';
import { getPendingSharedText, setPendingSharedText, } from '@/deeplink/PendingSharedText';
import { useLogger } from '@/logging/useLogger';
import { linkingScreensConfig } from '@/navigation/linkingConfig';
import { useTabBarStyle } from '@/navigation/useTabBarStyle';
import ToastUtils from '@/utils/ToastUtils';
import { stripPrefix } from '@/utils/deepLinkUtils';
import { useCheckAuth } from '@/utils/checkAuth';
import ChallengeIcon from '../../assets/icon/ic_challenge.svg';
import HomeIcon from '../../assets/icon/ic_home.svg';
import MapIcon from '../../assets/icon/ic_nav_map.svg';
import MenuIcon from '../../assets/icon/ic_menu.svg';
import ChallengeScreen from '../ChallengeScreen';
import HomeScreenV2 from '../HomeScreenV2';
import MenuScreen from '../MenuScreen';
import SearchScreen from '../SearchScreen';
const Tab = createBottomTabNavigator();
// Move tab bar icon components outside to avoid ESLint warnings
const HomeTabIcon = (props) => (_jsx(HomeIcon, { color: props.color }));
const MapTabIcon = (props) => _jsx(MapIcon, { color: props.color });
const ChallengeTabIcon = (props) => (_jsx(ChallengeIcon, { color: props.color }));
const MenuTabIcon = (props) => (_jsx(MenuIcon, { color: props.color }));
export default function MainScreen({ navigation }) {
    const accessToken = useAtomValue(accessTokenAtom);
    const checkAuth = useCheckAuth();
    const logger = useLogger();
    const tabBarStyle = useTabBarStyle();
    useEffect(() => {
        const checkIfLoggedIn = () => __awaiter(this, void 0, void 0, function* () {
            if (!accessToken) {
                navigation.replace('Login');
                ToastUtils.show('인증 정보가 유효하지 않습니다.');
            }
        });
        checkIfLoggedIn();
    }, [accessToken, navigation]);
    // Deferred deep link 소비: 로그인 완료 후 저장된 URL을 파싱해서 navigate
    useEffect(() => {
        if (!accessToken) {
            return;
        }
        const url = getDeferredDeepLinkUrl();
        if (!url) {
            return;
        }
        setDeferredDeepLinkUrl(null);
        const path = stripPrefix(url);
        if (!path) {
            return;
        }
        const state = getStateFromPath(path, linkingScreensConfig);
        if (!state) {
            return;
        }
        const action = getActionFromState(state, linkingScreensConfig);
        if (action) {
            navigation.dispatch(action);
        }
    }, [accessToken, navigation]);
    // 비로그인 상태에서 수신된 공유 텍스트 소비: 로그인 완료 후 ResolvingSharedLink로 이동
    useEffect(() => {
        if (!accessToken) {
            return;
        }
        const sharedText = getPendingSharedText();
        if (!sharedText) {
            return;
        }
        setPendingSharedText(null);
        navigation.navigate('ResolvingSharedLink', { sharedText });
    }, [accessToken, navigation]);
    return (_jsxs(Tab.Navigator, { screenOptions: {
            tabBarActiveTintColor: color.gray90,
            tabBarInactiveTintColor: color.gray40,
            tabBarLabelStyle: { fontSize: 10, fontWeight: '700' },
            tabBarStyle,
        }, children: [_jsx(Tab.Screen, { name: "Home", component: HomeScreenV2, listeners: {
                    tabPress: () => {
                        logger.logElementClick('main_tab_home');
                    },
                }, options: {
                    title: '홈',
                    headerShown: false,
                    tabBarIcon: HomeTabIcon,
                } }), _jsx(Tab.Screen, { name: "Search", component: SearchScreen, listeners: {
                    tabPress: () => {
                        logger.logElementClick('main_tab_search');
                    },
                }, options: {
                    title: '지도',
                    headerShown: false,
                    tabBarIcon: MapTabIcon,
                    freezeOnBlur: true,
                } }), _jsx(Tab.Screen, { name: "Challenge", component: ChallengeScreen, listeners: {
                    tabPress: () => {
                        logger.logElementClick('main_tab_challenge');
                    },
                }, options: {
                    title: '챌린지',
                    headerShown: false,
                    tabBarIcon: ChallengeTabIcon,
                } }), _jsx(Tab.Screen, { name: "Menu", component: MenuScreen, listeners: {
                    tabPress: e => {
                        logger.logElementClick('main_tab_menu');
                        checkAuth(() => { }, () => e.preventDefault());
                    },
                }, options: {
                    title: '메뉴',
                    headerShown: false,
                    tabBarIcon: MenuTabIcon,
                } })] }));
}
